import { useTranslation } from 'next-i18next';
import { CircularProgress } from '@components/common/Icons';
import { SanitizeHTML } from '@components/common'; // Import the SanitizeHTML component

interface EmptyEvaluateBiaProps {
  onValidateClick?: () => void;
  showValidateLink?: boolean;
}

/**
 * @description Component to render the empty evaluation section.
 */
export const EmptyEvaluateBia = ({ onValidateClick, showValidateLink = true }: EmptyEvaluateBiaProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col gap-4 py-3">
      <div className="flex items-center justify-between py-3 text-sm">
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="font-bold text-ink">{t('bia.evaluate.text')}</div>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-tiny font-bold text-ink-light">
              {t('evaluation_unavailable_waiting')}
            </span>
            <CircularProgress score={0} size={48} />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4 rounded-md bg-surface-100/50 p-6 text-start">
        <p className="text-lg font-medium text-ink">
          {t('evaluation_unavailable_subtitle')}
        </p>
        <p className="text-sm leading-relaxed text-ink-medium">
          <SanitizeHTML as="span" htmlContent={t('evaluation_unavailable_body')} />
          {showValidateLink && (
            <span
              role="presentation"
              onClick={onValidateClick}
              className="ml-1 cursor-pointer font-bold text-primary decoration-dotted underline-offset-4 hover:decoration-solid"
            >
              {t('cv.detail.action.validate')}
            </span>
          )}
        </p>
      </div>
    </div>
  );
};
